import React, { FC } from "react";

import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AlertTriangle: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faTriangleExclamation} {...props} />;
};
